import { connect } from 'react-redux'
import PricingTable from './PricingTable'
import showNumbersFormModal from 'features/Numbers/NumbersFormModal'
import showPhoneSystemFormModal from 'features/PhoneSystem/PhoneSystemFormModal'
import showInternetModal from 'features/Internet/InternetFormModal'
import { showMobileServiceFormModal } from 'features/MobileServices/MobileServiceFormModal'
import analytics from 'features/Analytics/Analytics.utils'
import showRatesModal from './RatesModal'

const stateToProps = () => ({})

const dispatchToProps = dispatch => ({
  showRatesModal: ({ rates }) => dispatch(showRatesModal({ rates })),
  signupModal: ({ productName, productId, productGroup }) => {
    analytics.track('Pricing Table - Click Choose', {
      productName,
      productId,
    })

    const items = {
      product1300Plans: () =>
        dispatch(showNumbersFormModal({ productName, productId, numberType: '1300' })),
      product1800Plans: () =>
        dispatch(showNumbersFormModal({ productName, productId, numberType: '1800' })),
      productLocal: () => dispatch(showNumbersFormModal({ numberType: 'local' })),
      productMobile: () => dispatch(showNumbersFormModal({ numberType: 'mobile' })),
      productPhoneVpbxPlans: () => dispatch(showPhoneSystemFormModal({ productName, productId })),
      productInternetFibre: () => dispatch(showInternetModal({ productName, productId })),
      productInternetNbn: () => dispatch(showInternetModal({ productName, productId })),
      virtualMobileService: () => dispatch(showMobileServiceFormModal()),
    }
    return items[productGroup]()
  },
})

export default connect(stateToProps, dispatchToProps)(PricingTable)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/PricingTable/PricingTable.container.js